import { analyticsClient } from "sdks/analytics";
import { EventField } from "sdks/analytics/types";

export const logMobileNumberClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'mobile_number',
        [EventField.OV]: 'mobile_number',
        [EventField.F1]: 'entered_mobile_number',
    });
};

export const logOTPEntered = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'otp_input',
        [EventField.OV]: 'otp_entered',
    });
};

export const logResendOTPClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'resend_otp',
        [EventField.OV]: 'resend_otp_click',
    });
};

export const logTermsAndConditionsClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'terms_and_conditions',
        [EventField.OV]: 'terms_and_conditions_click',
    });
};

export const logOTPErrorResponse = (error: string) => {
    analyticsClient.logImpression({
        [EventField.ON]: 'otp_error',
        [EventField.OV]: 'error_response',
        [EventField.F1]: JSON.stringify({ error: error }),
    });
};

export const logMobileNumberSubmitted = (mobileNumber: string) => {
    analyticsClient.logClick({
        [EventField.ON]: 'mobile_number',
        [EventField.OV]: 'submitted',
        [EventField.F1]: JSON.stringify({}),
    });
};

export const logMobileNumberSubmitFailed = (mobileNumber: string, error: string) => {
    analyticsClient.logClick({
        [EventField.ON]: 'mobile_number',
        [EventField.OV]: 'failure',
        [EventField.F1]: JSON.stringify({ error: error }),
    });
};

export const logContinueButtonClick = () => {
    analyticsClient.logClick({
        [EventField.ON]: 'otp_verification',
        [EventField.OV]: 'continue_btn',
    });
};